import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ApiError } from '../lib/api'

type Props = {
  onCancel: () => void
  onVerified: () => void
  runStepUp: () => Promise<unknown>
}

export function StepUpModal({ onCancel, onVerified, runStepUp }: Props) {
  const { t } = useTranslation()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function confirm() {
    setBusy(true)
    setError(null)
    try {
      await runStepUp()
      onVerified()
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t('auth.stepUpFailed'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="modal-backdrop" role="presentation">
      <div className="modal card" role="dialog" aria-modal="true" aria-labelledby="stepup-title">
        <h2 id="stepup-title">{t('auth.stepUpTitle')}</h2>
        <p className="lede">{t('auth.stepUpLede')}</p>
        {error ? (
          <p className="warn" role="alert">
            {error}
          </p>
        ) : null}
        <div className="welcome-actions">
          <button type="button" className="btn btn-primary" disabled={busy} onClick={() => void confirm()}>
            {busy ? t('auth.working') : t('auth.stepUpConfirm')}
          </button>
          <button type="button" className="btn" disabled={busy} onClick={onCancel}>
            {t('auth.cancel')}
          </button>
        </div>
      </div>
    </div>
  )
}
